import anime from 'animejs'

export const HeroTimeline = {
	ran: false,

	start: function() {
		if (this.ran) return

		anime.timeline().add({
			targets: '#Hero--Cover',
			opacity: [0, 0.1],
			easing: 'easeOutExpo',
			delay: 2200,
			duration: 2000,
		})

		this.ran = true
	},
}
